import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import {replacePlaceholders} from '../../../../utilities/StringHelpers/TitleHelpers';
import errorIcon from '../Icons/error.svg';

const MessagePopup = (props) => {
  const {icon, title, secondTitle, buttonText, secondButtonText, report} = props.popupData;

  useEffect(() => {
    dwhReportOnLoad();
  }, [props.popupData]);

  function dwhReportOnLoad() {
    switch (report) {
      case 'openWorkOrder':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorOpenOrderDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorNPStatus':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorUserBNIYODDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorAbroad':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorUserisabroadDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorEsim':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErroreSIMDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorSubStatus':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorUserpostponedDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'errorDataPackage':
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorDataUserDisplayed,
          status: DWHStatus.Error,
        });
        break;
      case 'transferGeneralError': //Business?
        dwhGeneralReport({
          data: {...props.data, userDetails: props.userDetails},
          actionType: DwhActionType.SelectLineAddressPage,
          messageText: DWHMessageText.ErrorBusinessUserDisplayed,
          status: DWHStatus.Error,
        });
        break;
      default:
        break;
    }
  }

  function submitButtonClick() {
    props.buttonClick();
  }
  function submitSecondButtonClick() {
    props.secondButtonClick();
  }

  return (
    <div className='messagePopup'>
      <Image src={icon ? icon : errorIcon} />
      <div className='l-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(title, props.data, isMobile)}} />
      {secondTitle && (
        <div className='m-title' dangerouslySetInnerHTML={{__html: replacePlaceholders(secondTitle, props.data, isMobile)}} />
      )}

      <div className='buttons'>
        <BtnSubmit className={`${secondButtonText && !isMobile ? 'in-row' : ''}`} text={buttonText} onclick={() => submitButtonClick()} />
        {secondButtonText && <BtnWhiteBlackBorderBigSize text={secondButtonText} onclick={() => submitSecondButtonClick()} />}
      </div>
    </div>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
  userDetails: state.authentication?.loginData?.userDetails,
});
export default connect(mapStateToProps, mapDispatchToProps)(MessagePopup);
